import React from "react";
// import logo from "../../asset/images/Bajaj_logo_login.svg";
import logo from "../../asset/images/bajaj-logoNew.svg"
import whiteLogo from "../../asset/images/bajaj-logoNew-dark.svg";

function Formnav() {
  return (
    <>
      {/* <div className="col-md-12"> */}
      <div className="main-logo">
        <img src={logo} alt="" className="lightmodelogo" />
        <img src={whiteLogo} alt="" className="darkmodelogo" />
      </div>
      {/* </div> */}
    </>
  );
}

export default Formnav;
